// List of Primary Schools in Singapore
// Source: Ministry of Education Singapore
// This list can be updated as needed

export const PRIMARY_SCHOOLS = [
  "Admiralty Primary School",
  "Ahmad Ibrahim Primary School",
  "Ai Tong School",
  "Alexandra Primary School",
  "Anchor Green Primary School",
  "Anderson Primary School",
  "Ang Mo Kio Primary School",
  "Anglo-Chinese School (Junior)",
  "Anglo-Chinese School (Primary)",
  "Angsana Primary School",
  "Beacon Primary School",
  "Bedok Green Primary School",
  "Bendemeer Primary School",
  "Blangah Rise Primary School",
  "Boon Lay Garden Primary School",
  "Broadrick Secondary School",
  "Bukit Panjang Primary School",
  "Bukit Timah Primary School",
  "Bukit View Primary School",
  "Canossa Catholic Primary School",
  "Canberra Primary School",
  "Casuarina Primary School",
  "Catholic High School (Primary)",
  "Cedar Primary School",
  "Changkat Primary School",
  "Chij (Katong) Primary",
  "Chij (Kellock)",
  "Chij Our Lady Of Good Counsel",
  "Chij Our Lady Of The Nativity",
  "Chij Our Lady Queen Of Peace",
  "Chij Primary (Toa Payoh)",
  "Chij St. Nicholas Girls' School (Primary)",
  "Clementi Primary School",
  "Compassvale Primary School",
  "Concord Primary School",
  "Coral Primary School",
  "Corporation Primary School",
  "Damai Primary School",
  "Dazhong Primary School",
  "De La Salle School",
  "Edgefield Primary School",
  "Elias Park Primary School",
  "Endeavour Primary School",
  "Eunos Primary School",
  "Evergreen Primary School",
  "Fairfield Methodist School (Primary)",
  "Farrer Park Primary School",
  "Fengshan Primary School",
  "Fern Green Primary School",
  "Fernvale Primary School",
  "First Toa Payoh Primary School",
  "Frontier Primary School",
  "Fuchun Primary School",
  "Fuhua Primary School",
  "Gan Eng Seng Primary School",
  "Geylang Methodist School (Primary)",
  "Gongshang Primary School",
  "Greendale Primary School",
  "Greenridge Primary School",
  "Greenwood Primary School",
  "Griffiths Primary School",
  "Guangyang Primary School",
  "Haig Girls' School",
  "Hamilton Primary School",
  "Henry Park Primary School",
  "Horizon Primary School",
  "Hougang Primary School",
  "Huamin Primary School",
  "Innova Primary School",
  "Jiemin Primary School",
  "Jing Shan Primary School",
  "Junyuan Primary School",
  "Jurong Primary School",
  "Jurong West Primary School",
  "Keming Primary School",
  "Kheng Cheng School",
  "Kong Hwa School",
  "Kranji Primary School",
  "Kuo Chuan Presbyterian Primary School",
  "Lakeside Primary School",
  "Lianhua Primary School",
  "Loyang Primary School",
  "MacPherson Primary School",
  "Maha Bodhi School",
  "Maris Stella High School (Primary)",
  "Marsiling Primary School",
  "Marymount Convent School",
  "Mayflower Primary School",
  "Mee Toh School",
  "Meridian Primary School",
  "Methodist Girls' School (Primary)",
  "Montfort Junior School",
  "Nanhua Primary School",
  "Nanyang Primary School",
  "Naval Base Primary School",
  "New Town Primary School",
  "Ngee Ann Primary School",
  "North Spring Primary School",
  "North View Primary School",
  "North Vista Primary School",
  "Northland Primary School",
  "Northoaks Primary School",
  "Northshore Primary School",
  "Oasis Primary School",
  "Opera Estate Primary School",
  "Paya Lebar Methodist Girls' School (Primary)",
  "Pei Chun Public School",
  "Pei Hwa Presbyterian Primary School",
  "Pei Tong Primary School",
  "Pasir Ris Primary School",
  "Pathlight School",
  "Peicai Primary School",
  "Pierce Primary School",
  "Pioneer Primary School",
  "Poi Ching School",
  "Princess Elizabeth Primary School",
  "Punggol Cove Primary School",
  "Punggol Green Primary School",
  "Punggol Primary School",
  "Punggol View Primary School",
  "Qifa Primary School",
  "Qihua Primary School",
  "Queenstown Primary School",
  "Raffles Girls' Primary School",
  "Red Swastika School",
  "River Valley Primary School",
  "Rivervale Primary School",
  "Riverside Primary School",
  "Rosyth School",
  "Radin Mas Primary School",
  "Rulang Primary School",
  "St. Andrew's Junior School",
  "St. Anthony's Canossian Primary School",
  "St. Anthony's Primary School",
  "St. Gabriel's Primary School",
  "St. Hilda's Primary School",
  "St. Joseph's Institution Junior",
  "St. Margaret's Primary School",
  "St. Stephen's School",
  "Sembawang Primary School",
  "Seng Kang Primary School",
  "Sengkang Green Primary School",
  "Senoko Primary School",
  "Shuqun Primary School",
  "Si Ling Primary School",
  "Singapore Chinese Girls' Primary School",
  "Singapura Primary School",
  "South View Primary School",
  "Stamford Primary School",
  "Springdale Primary School",
  "Tampines North Primary School",
  "Tampines Primary School",
  "Tanjong Katong Primary School",
  "Tao Nan School",
  "Teck Ghee Primary School",
  "Teck Whye Primary School",
  "Telok Kurau Primary School",
  "Temasek Primary School",
  "Townsville Primary School",
  "Unity Primary School",
  "Valour Primary School",
  "Waterway Primary School",
  "Wellington Primary School",
  "West Grove Primary School",
  "West Spring Primary School",
  "West View Primary School",
  "Westwood Primary School",
  "White Sands Primary School",
  "Woodgrove Primary School",
  "Woodlands Primary School",
  "Woodlands Ring Primary School",
  "Xinghua Primary School",
  "Xingnan Primary School",
  "Xinmin Primary School",
  "Xishan Primary School",
  "Yangzheng Primary School",
  "Yew Tee Primary School",
  "Yio Chu Kang Primary School",
  "Yishun Primary School",
  "Yu Neng Primary School",
  "Yuhua Primary School",
  "Yumin Primary School",
  "Zhangde Primary School",
  "Zhenghua Primary School",
  "Zhonghua Primary School"
].sort();
